/* eslint-disable react/no-unknown-property */
import {
  Action, Icon, Message, Skeleton, Spacing,
  Stack,
  Text,
} from '@doveit/bricks';
import { pluralizeWord } from '@doveit/hammer';
import React from 'react';
import * as styles from './WelcomeBox.style';

export const LOAD_CONTACT_COUNT_ERROR_MESSAGE = 'Impossibile caricare il numero di contatti da processare';

export interface WelcomeBoxProps extends React.AriaAttributes {
  label: string,
  icon: string,
  loading?: boolean,
  count?: number,
  isContactCountError: boolean,
  isContactCountLoading: boolean
  onStartClick: VoidFunction,
  onRefreshClick: VoidFunction,
}

const WelcomeBox: React.FC<WelcomeBoxProps> = ({
  label,
  icon,
  loading,
  count,
  onStartClick,
  onRefreshClick,
  isContactCountError,
  isContactCountLoading,
  ...rest
}) => {
  const renderContactCount = React.useMemo(() => count !== undefined && count >= 0, [count]);

  return (
    <div
      {...rest}
      css={styles.base}
    >
      <Stack gap={150} alignItems="center">
        <Icon
          path={icon}
          size={60}
        />
        <div css={styles.message}>
          {renderContactCount && (
            <>
              <Text.H2>
                {count}
              </Text.H2>
              <Text.BodySmall>
                {`${pluralizeWord('Contatt', 'o', 'i', count!)} da processare`}
              </Text.BodySmall>
            </>
          )}
          {!renderContactCount && isContactCountLoading && (
            <Skeleton count={3} width="7rem" />
          )}
        </div>

        {isContactCountError && (
          <Message
            type="critical"
            message={LOAD_CONTACT_COUNT_ERROR_MESSAGE}
          />
        )}

        <Spacing margin={[150, 0, 0, 0]}>
          <Action
            loading={loading}
            label={`Processa ${label}`}
            aria-label={`Processa ${label}`}
            color="primary"
            emphasis="high"
            disabled={!count}
            onClick={count ? onStartClick : onRefreshClick}
          />
        </Spacing>
      </Stack>
    </div>
  );
};

export default WelcomeBox;
